import * as React from 'react'
const SvgSuccessTrueFilled = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="56"
    height="56"
    fill="none"
    viewBox="0 0 56 56"
    {...props}
  >
    <rect width="48" height="48" x="4" y="4" fill="#12B76A" rx="24"></rect>
    <path
      stroke="#fff"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
      d="M36 22L25 33l-5-5"
    ></path>
    <rect
      width="48"
      height="48"
      x="4"
      y="4"
      stroke="#D1FADF"
      strokeWidth="8"
      rx="24"
    ></rect>
  </svg>
)
export default SvgSuccessTrueFilled
